var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 61,
    viewBox: "0 0 82 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69.9981,
    height: 56.5853,
    rx: 11,
    fill: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8979C0 4.87916 4.87916 0 10.8979 0H59.1002C65.1189 0 69.9981 4.87916 69.9981 10.8979V10.8979H0V10.8979Z",
    fill: "#18C347"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.01156,
    cy: 4.82016,
    r: 1.6766,
    fill: "#305F1A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0892,
    cy: 4.82016,
    r: 1.6766,
    fill: "#96D36E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1673,
    cy: 4.82016,
    r: 1.6766,
    fill: "#519F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.33497 18.2099C7.33614 17.4049 7.57602 16.6183 8.02429 15.9497C8.47255 15.281 9.10906 14.7603 9.85329 14.4535C10.5975 14.1466 11.416 14.0674 12.2053 14.2258C12.9946 14.3842 13.7191 14.7732 14.2873 15.3434C14.8555 15.9137 15.2418 16.6396 15.3973 17.4295C15.5529 18.2193 15.4707 19.0375 15.1611 19.7806C14.8516 20.5237 14.3286 21.1584 13.6583 21.6042C12.988 22.05 12.2006 22.2871 11.3956 22.2853C10.8613 22.2847 10.3323 22.1788 9.83895 21.9736C9.34559 21.7684 8.89753 21.4679 8.52039 21.0894C8.14325 20.7109 7.84444 20.2618 7.64103 19.7677C7.43763 19.2736 7.33362 18.7442 7.33497 18.2099V18.2099Z",
    fill: "#18C347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.474 28.3867C15.4739 29.1917 15.2351 29.9786 14.7877 30.6479C14.3403 31.3171 13.7044 31.8386 12.9606 32.1465C12.2168 32.4543 11.3983 32.5346 10.6089 32.3772C9.81938 32.2198 9.09431 31.8318 8.52538 31.2623C7.95645 30.6927 7.56922 29.9672 7.41266 29.1776C7.25611 28.388 7.33726 27.5696 7.64587 26.8261C7.95448 26.0826 8.47667 25.4473 9.14638 25.0006C9.8161 24.5539 10.6032 24.3159 11.4083 24.3167C11.9425 24.3169 12.4714 24.4223 12.9649 24.627C13.4584 24.8317 13.9067 25.1315 14.2842 25.5095C14.6618 25.8875 14.9612 26.3361 15.1653 26.8298C15.3695 27.3234 15.4744 27.8525 15.474 28.3867V28.3867ZM11.4072 30.4266C11.8093 30.425 12.2019 30.3043 12.5354 30.0797C12.8689 29.855 13.1283 29.5366 13.2809 29.1646C13.4335 28.7926 13.4724 28.3837 13.3927 27.9896C13.313 27.5955 13.1183 27.2339 12.8332 26.9504C12.5481 26.6669 12.1853 26.4742 11.7907 26.3968C11.3962 26.3194 10.9875 26.3607 10.6164 26.5154C10.2453 26.6702 9.92836 26.9314 9.70566 27.2662C9.48297 27.601 9.3645 27.9943 9.36522 28.3964C9.36851 28.9358 9.58509 29.4521 9.96766 29.8324C10.3502 30.2128 10.8677 30.4263 11.4072 30.4265V30.4266Z",
    fill: "#18C347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.6854 16.1929V18.1898H17.5303V16.1929H27.6854Z",
    fill: "#18C347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.6824 24.3047H17.5347V22.3015H27.6824V24.3047Z",
    fill: "#18C347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.5161 30.4126C17.5161 29.7734 17.5161 29.1552 17.5172 28.5349C17.5192 28.4943 17.5235 28.4538 17.53 28.4136H27.6853V30.4126H17.5161Z",
    fill: "#18C347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.6274 47.0781H15.1201V60.8235H24.6274V47.0781Z",
    fill: "#18C347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M36.082 35.6235H26.5747V60.8235H36.082V35.6235Z",
    fill: "#18C347"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.4215 40.2053H38.0288V60.8234H47.4215V40.2053Z",
    fill: "#18C347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M58.6471 24.3982H49.2544V60.8235H58.6471V24.3982Z",
    fill: "#18C347"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M70.331 30.0107H60.8237V60.8234H70.331V30.0107Z",
    fill: "#18C347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.3271 38.4871H71.8198V60.8234H81.3271V38.4871Z",
    fill: "#18C347"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingDark);
export default __webpack_public_path__ + "static/media/trading-dark.9149f70cb7df323e58e38b35ed1d8cf6.svg";
export { ForwardRef as ReactComponent };